// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Atom_Text from "./Atom_Text.bs.js";
import * as Atom_Image from "./Atom_Image.bs.js";
import * as Atom_Column from "./Atom_Column.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Atom_ImageWithCaption_Ds from "./Atom_ImageWithCaption_Ds.bs.js";
import * as Atom_ImageWithCaption_Css from "./Atom_ImageWithCaption_Css.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";

function Atom_ImageWithCaption$Internal(Props) {
  var imageComponent = Props.imageComponent;
  var copyright = Props.copyright;
  var title = Props.title;
  var layout = Props.layout;
  var view = Atom_ImageWithCaption_Ds.view(Atom_ImageWithCaption_Ds.make(layout));
  var text = view.text;
  var rules = Atom_ImageWithCaption_Css.toCss(view);
  var match = text.title;
  var title$1 = title !== undefined && match !== undefined ? React.createElement(Atom_Text.make, {
          children: title,
          style: match
        }) : null;
  var copyrightComponent = copyright !== undefined ? React.createElement(Atom_Text.make, {
          children: copyright,
          style: text.copyright
        }) : null;
  return React.createElement(Atom_Column.make, {
              alignItems: Particle_Screen_Constants.alignItemsCenter,
              children: null
            }, imageComponent, React.createElement(Atom_Column.make, {
                  alignItems: Particle_Screen_Constants.alignItemsCenter,
                  blockSpace: view.blockSpace,
                  children: null,
                  rules: rules
                }, title$1, copyrightComponent));
}

var Internal = {
  make: Atom_ImageWithCaption$Internal
};

function Atom_ImageWithCaption$Corporate(Props) {
  var alt = Props.alt;
  var layout = Props.layout;
  var src = Props.src;
  var copyright = Props.copyright;
  var title = Props.title;
  var imageComponent = React.createElement(Atom_Image.ImageTmp.make, {
        alt: alt,
        src: src,
        style: {
          TAG: /* WithCaption */4,
          _0: undefined,
          _1: undefined
        }
      });
  var tmp = {
    imageComponent: imageComponent,
    layout: layout
  };
  if (copyright !== undefined) {
    tmp.copyright = Caml_option.valFromOption(copyright);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement(Atom_ImageWithCaption$Internal, tmp);
}

var Corporate = {
  make: Atom_ImageWithCaption$Corporate
};

function Atom_ImageWithCaption(Props) {
  var alt = Props.alt;
  var layout = Props.layout;
  var srcByBreakpoints = Props.srcByBreakpoints;
  var copyright = Props.copyright;
  var title = Props.title;
  var $$default = srcByBreakpoints.default;
  var xl = srcByBreakpoints.xl;
  var l = srcByBreakpoints.l;
  var m = srcByBreakpoints.m;
  var s = srcByBreakpoints.s;
  var xs = srcByBreakpoints.xs;
  var ds = Particle_Screen_Ds.make(xs, s, m, l, xl, $$default);
  var size = Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "FullAuto"));
  var src = [
    $$default,
    xs,
    s,
    m,
    l,
    xl
  ];
  var width = Caml_option.some(Particle_Screen_Ds.map((function (param) {
              return param.w;
            }), ds));
  var imageComponent = React.createElement(Atom_Image.make, {
        alt: alt,
        src: src,
        style: {
          TAG: /* WithCaption */4,
          _0: size,
          _1: width
        }
      });
  var tmp = {
    imageComponent: imageComponent,
    layout: layout
  };
  if (copyright !== undefined) {
    tmp.copyright = Caml_option.valFromOption(copyright);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement(Atom_ImageWithCaption$Internal, tmp);
}

var make = Atom_ImageWithCaption;

export {
  Internal ,
  Corporate ,
  make ,
}
/* react Not a pure module */
